console.log("🔥 BUNDLE-PRICE.JS IS RUNNING 🔥");

(async () => {

    const cache = {};


    async function getProduct(handle) {

        if (cache[handle]) {
            return cache[handle];
        }

        const response = await fetch(`/products/${handle}.js`);

        if (!response.ok) {
            throw new Error(`Could not load product: ${handle}`);
        }

        const product = await response.json();

        cache[handle] = product;

        return product;
    }


    function money(cents) {

        return new Intl.NumberFormat("en-NZ", {

            style: "currency",

            currency: "NZD",

            minimumFractionDigits: 0,

            maximumFractionDigits: 0

        }).format(cents / 100);

    }


    console.log(
        "Bundle config:",
        window.bundleConfig
    );


    const bundles = document.querySelectorAll(".bundle-price");


    console.log(
        "Bundle elements found:",
        bundles.length
    );


    for (const bundle of bundles) {

        const handle = bundle.dataset.handle;

        console.log(
            "Processing bundle:",
            handle
        );


        if (!window.bundleConfig) {

            console.error(
                "window.bundleConfig does not exist"
            );

            continue;

        }


        const config = window.bundleConfig[handle];


        console.log(
            "Config for this bundle:",
            config
        );


        if (!config) {

            console.warn(
                "No bundle config found for:",
                handle
            );

            continue;

        }


        try {

            // ==========================================
            // GET PRODUCTS
            // ==========================================

            const products = await Promise.all(

                config.products.map(getProduct)

            );


            console.log(
                "Products loaded:",
                products
            );


            // ==========================================
            // CALCULATE ORIGINAL TOTAL
            // ==========================================

            let total = 0;


            products.forEach(product => {

                const productPrice =
                    Number(product.variants[0].price);

                console.log(
                    product.handle,
                    "price:",
                    productPrice / 100
                );

                total += productPrice;

            });


            console.log(
                "ORIGINAL TOTAL:",
                total / 100
            );


            // ==========================================
            // CALCULATE SALE PRICE
            // ==========================================

            let salePrice;


            if (config.type === "percentage") {

                console.log(
                    "Using percentage discount:",
                    config.discount
                );


                salePrice = Math.round(

                    total *
                    (1 - config.discount / 100)

                );

            }


    else if (config.type === "fixed") {

    console.log(
        "Using total product value as fixed sale price"
    );

    salePrice = total;

}


            else {

                console.warn(
                    "No valid bundle type. Using total."
                );


                salePrice = total;

            }


            console.log(
                "SALE PRICE:",
                salePrice / 100
            );


            // ==========================================
            // FIND PRICE ELEMENTS
            // ==========================================

       const price =
    bundle.querySelector(
        ".bundle-price__sale"
    );

const compare =
    bundle.querySelector(
        ".bundle-price__compare"
    );


            console.log(
                "Price element:",
                price
            );


            console.log(
                "Compare element:",
                compare
            );


            // ==========================================
            // DISPLAY SALE PRICE
            // ==========================================

            if (price) {

                price.textContent =
                    money(salePrice);

            }


            // ==========================================
            // DISPLAY ORIGINAL PRICE
            // ==========================================

            if (compare) {

                if (salePrice < total) {

                    compare.textContent =
                        money(total);

                    compare.style.display =
                        "inline";

                }

                else {

                    compare.textContent =
                        "";

                    compare.style.display =
                        "none";

                }

            }


        } catch (error) {

            console.error(
                "BUNDLE PRICE ERROR:",
                handle,
                error
            );

        }

    }

})();